/* pillar.js: behaviour for sections/pillar-main.liquid + pillar-library.liquid (build spec v3).
   Filters, the "Find your stool" chooser (logic ported 1:1 from the approved mockup; every
   string, list, width and reason comes from the pillar.page JSON), the five "before you
   choose" cards and their detail dialogs, compare pickers, guides, FAQ, the mobile sticky
   bar and the samples drawer. No framework; the page works without this file. */
(function () {
  var root = document.querySelector('[data-plr]');
  if (!root) return;
  var lib = document.querySelector('[data-plr-lib]');
  var roots = [root, lib].filter(Boolean);
  roots.forEach(function (r) { r.classList.add('js'); });

  /* Card image swipe: past the packshot the colour squares fade out completely (they belong to the packshot, not to
     a room photo); back on the first image they fade in again (Alexander 2026-10-31). */
  /* The grid may live in its own section (shop-pillar, 2026-11-03), so grid hooks are looked up page-wide. */
  [].slice.call(document.querySelectorAll('.plr-card__track[data-plr-swipe]')).forEach(function (t) {
    var card = t.closest('.plr-card');
    t.addEventListener('scroll', function () {
      card.classList.toggle('is-swiped', t.scrollLeft > t.clientWidth * 0.25);
    }, { passive: true });
  });

  /* Preview before the flip (?view=pillar on a hub): carry the template along when someone clicks from the hub into a
     subcollection or back, so the whole family can be walked through on the draft (Alexander 2026-10-31). Nobody
     uses ?view on the live site, so this does nothing there. */
  (function () {
    var v = new URLSearchParams(location.search).get('view');
    if (v !== 'pillar' && v !== 'subpillar') return;
    // Chips, the sub page's chip row and its "more" cards: the hub link (first chip, the All card) keeps the pillar,
    // every other collection link opens as a subcollection.
    [].slice.call(document.querySelectorAll('.plr-chips a, .plr-chips--sub a, #more a')).forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.href);
        if (u.origin !== location.origin || u.pathname.indexOf('/collections/') < 0) return;
        var isHub = a.matches('.plr-chips--sub a:first-child, .plr-subcard--all') || (!a.hasAttribute('data-plr-sub') && a.closest('.plr-chips') && !a.closest('.plr-chips--sub'));
        u.searchParams.set('view', isHub ? 'pillar' : 'subpillar');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  })();

  // The plain fallback (no pillar.page yet) has cards but no page data: the swipe above is all it needs.
  var dataEl = root.querySelector('[data-plr-data]');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var T = (D.ch && D.ch.t) || {}, U = D.ui, M = D.models, R = D.root || '';
  var MOB = window.matchMedia('(max-width: 767px)');
  var KEY = 'plr:' + location.pathname.split('?')[0];
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || document).querySelectorAll(s)); };
  // US market (pillar.page unit "in"): every length the page writes goes through fmt, so "66 cm" or
  // "50 to 60 cm" become inches here, to the nearest half inch. The finder still computes in cm.
  var IN = D.unit === 'in';
  function toIn(v) { return String(Math.round(v / 2.54 * 2) / 2); }
  function inch(s) {
    return !IN ? s : s.replace(/(\d+(?:\.\d+)?)((?:(?: to | and | or |, )\d+(?:\.\d+)?)*) ?cm\b/g, function (m, a, rest) {
      return toIn(+a) + rest.replace(/\d+(?:\.\d+)?/g, function (n) { return toIn(+n); }) + ' in';
    });
  }
  function fmt(s, o) { s = String(s == null ? '' : s); for (var k in o) s = s.split('%' + k).join(o[k]); return inch(s); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cm(v) { return fmt(T.cm || '%v cm', { v: v }); }
  function noun(n) { return n === 1 ? U.noun[0] : U.noun[1]; }
  function ev(name, p) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name, pillar: KEY }, p || {})); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY + k)); sessionStorage.setItem(KEY + k, JSON.stringify(v)); } catch (e) { return null; } }
  var PROD = {};
  D.prod.forEach(function (p) { if (p.id && p.id !== '-' && !PROD[p.id]) PROD[p.id] = p; });
  var q = new URLSearchParams(location.search);
  ev('pillar_view', { locale: document.documentElement.lang });

  /* Sticky header offset for the chips, anchors and card targets. */
  var header = document.querySelector('.shopify-section-group-header-group[class*="main-header"], [id$="__main-header"]');
  function setHead() { var h = header ? Math.round(header.getBoundingClientRect().height) : 64; roots.forEach(function (r) { r.style.setProperty('--head', (h || 64) + 'px'); }); }
  setHead(); window.addEventListener('resize', setHead);
  function scrollToEl(el) {
    if (!el) return;
    var head = parseInt(getComputedStyle(root).getPropertyValue('--head'), 10) || 64;
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - head + 1, behavior: smooth ? 'smooth' : 'auto' });
  }

  /* Arriving from a filter chip (#shop): open at the shop heading, instantly, once the page has its final layout, so
     moving between the pillar and a subcollection reads as a filter rather than a page change. */
  if (location.hash === '#shop') {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var toShop = function () {
      var s = $('#shop'); if (!s) return;
      var head = parseInt(getComputedStyle(root).getPropertyValue('--head'), 10) || 64;
      window.scrollTo(0, s.getBoundingClientRect().top + window.scrollY - head + 1);
    };
    requestAnimationFrame(toShop);
    if (document.readyState === 'complete') toShop(); else window.addEventListener('load', toShop);
  }

  /* Inspiration strip: the arrows step one card; they dim at either end. Phones swipe natively. */
  $$('[data-plr-lb]', root).forEach(function (lb) {
    var tr = $('[data-plr-lb-track]', lb), btns = $$('[data-plr-lb-step]', lb);
    var upd = function () {
      var end = tr.scrollWidth - tr.clientWidth - 2;
      btns.forEach(function (b) { b.disabled = +b.dataset.plrLbStep < 0 ? tr.scrollLeft <= 2 : tr.scrollLeft >= end; });
    };
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var c = $('.plr-lb__cell', tr), w = c ? c.getBoundingClientRect().width + 24 : tr.clientWidth * .8;
        tr.scrollBy({ left: +b.dataset.plrLbStep * w, behavior: 'smooth' });
      });
    });
    tr.addEventListener('scroll', upd, { passive: true });
    upd();
    lb.addEventListener('click', function (e) { if (e.target.closest('[data-plr-lb-card]')) ev('inspiration_click', {}); });
  });

  /* Tile video: the right file for the width, loaded near the viewport, played only while visible; reduced motion
     keeps the poster. */
  var vids = $$('[data-plr-video]');
  if (vids.length && 'IntersectionObserver' in window) {
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches, wide = window.matchMedia('(min-width:768px)');
    vids.forEach(function (v) {
      /* Pick the cut by the box's own shape, not the screen: the tile is landscape on phones too. */
      var land = v.clientWidth >= v.clientHeight, key = land || wide.matches ? 'd' : 'm';
      var pst = v.getAttribute('data-poster-' + key); if (pst) v.poster = pst;
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            if (!v.src) { v.src = v.getAttribute('data-src-' + key); }
            if (!still) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          } else if (!v.paused) v.pause();
        });
      }, { rootMargin: '200px 0px' });
      vio.observe(v);
    });
  }

  /* ---------- samples drawer (the existing site drawer, never a new one) ---------- */
  function openSamples(source) {
    var tab = document.querySelector('.pdp-samples [data-samples-open]');
    if (!tab) return false;
    var drawer = tab.closest('.pdp-samples');
    if (!drawer.classList.contains('is-open')) tab.click();
    var grp = drawer.querySelector('[data-samples-group="fabric-samples"] details');
    if (grp) grp.open = true;
    ev('samples_open', { source: source || 'page' });
    return true;
  }
  window.byCrea = window.byCrea || {};
  if (!window.byCrea.openSamples) window.byCrea.openSamples = openSamples;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-plr-samples]');
    if (a && openSamples(a.getAttribute('data-plr-samples'))) { e.preventDefault(); closeDetail(); }
    var g = e.target.closest && e.target.closest('[data-plr-guide]');
    if (g) ev('guide_click', { url: g.getAttribute('href'), source: g.getAttribute('data-plr-guide') });
  });

  /* ---------- filters ---------- */
  var grid = $('[data-plr-grid]'), cards = grid ? $$('[data-card]', grid) : [], tiles = grid ? $$('[data-tile]', grid) : [];
  var chips = $$('[data-filter]'), matchChip = $('[data-filter="match"]');
  var countEl = $('[data-plr-count]') || document.createElement('span');
  var FILTERS = {
    all: function () { return true; }, oak: function (c) { return c.dataset.mat === 'oak'; }, steel: function (c) { return c.dataset.mat === 'steel'; },
    back: function (c) { return c.dataset.back && c.dataset.back !== 'none'; }, backless: function (c) { return c.dataset.back === 'none'; },
    arms: function (c) { return c.dataset.back === 'arms'; },
    match: function (c) { return matches && matches.indexOf(c.dataset.mid) > -1; }
  };
  // Data-driven chips carry their own rule (pillar.page chip_filters: field + eq). The card writes material as data-mat.
  var FIELD = { material: 'mat' };
  chips.forEach(function (c) {
    var fd = c.dataset.field, eq = c.dataset.eq;
    if (fd) FILTERS[c.dataset.filter] = function (card) { return card.getAttribute('data-' + (FIELD[fd] || fd)) === eq; };
  });
  var inspo = $('[data-plr-inspo]', root);
  var filter = 'all', matches = store(':matches');
  function setFilter(k, silent) {
    if (k === 'inspiration' && !inspo) k = 'all';
    if (k !== 'inspiration' && (!FILTERS[k] || (k === 'match' && !matches))) k = 'all';
    filter = k;
    var n = 0;
    if (inspo) { inspo.hidden = k !== 'inspiration'; grid.hidden = k === 'inspiration'; }
    if (k === 'inspiration') {
      inflateInspo();
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.filter === k)); });
      countEl.textContent = fmt(U.inspo_count, { n: inspo.getAttribute('data-n') });
      var iu = new URL(location.href); iu.searchParams.set('filter', k); history.replaceState(history.state, '', iu);
      if (!silent) ev('pillar_filter', { key: k, count: +inspo.getAttribute('data-n') });
      return;
    }
    cards.forEach(function (c) {
      var on = FILTERS[k](c); c.hidden = !on; if (on) n++;
      c.style.order = k === 'match' && on ? String(matches.indexOf(c.dataset.mid)) : '';
    });
    tiles.forEach(function (t) { t.hidden = k !== 'all'; });
    chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.filter === k)); });
    countEl.textContent = fmt(U.count_label, { n: n, u: noun(n) });
    var url = new URL(location.href);
    if (k === 'all' || k === 'match') url.searchParams.delete('filter'); else url.searchParams.set('filter', k);
    history.replaceState(history.state, '', url);
    if (!silent) ev('pillar_filter', { key: k, count: n });
  }
  function showMatchChip() {
    if (!matches) return;
    if (!matchChip) {
      var mt = $('template[data-plr-match-tpl]');
      if (!mt) return;
      mt.parentNode.insertBefore(mt.content.cloneNode(true), mt); mt.remove();
      matchChip = $('[data-filter="match"]');
      chips.push(matchChip);
      matchChip.addEventListener('click', function () { setFilter('match'); });
    }
    matchChip.hidden = false;
    var nm = $('[data-plr-nmatch]'); if (nm) nm.textContent = matches.length;
    updSticky();
  }
  chips.forEach(function (c) { c.addEventListener('click', function () { setFilter(c.dataset.filter); }); });
  cards.forEach(function (c, i) { c.addEventListener('click', function (e) { if (e.target.closest('[data-action="toggle-favorites"]')) return; ev('select_item', { item_id: c.dataset.mid, index: i + 1, list: 'pillar_grid', filter: filter }); }); });
  // The Inspiration photos ship inside a <template>, so the page's readable content lists each
  // product once (the grid); the mosaic only enters the DOM when a shopper opens it.
  function inflateInspo() {
    var tpl = inspo && $('template[data-plr-inspo-tpl]', inspo);
    if (!tpl) return;
    inspo.appendChild(tpl.content.cloneNode(true)); tpl.remove();
    $$('.plr-inspo__cell', inspo).forEach(function (c, i) { c.addEventListener('click', function () { ev('select_item', { item_id: c.dataset.inspoPid, index: i + 1, list: 'pillar_inspiration' }); }); });
  }
  showMatchChip();
  if (q.get('filter')) setFilter(q.get('filter'), true);
  function goShop(src) { closeChooser(); scrollToEl($('#shop')); if (src) ev('pillar_hero_cta', { cta: 'shop', source: src }); }
  $$('[data-plr-go]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); if (a.hasAttribute('data-plr-sticky-shop') && matches) setFilter('match'); goShop(a.getAttribute('data-plr-go')); }); });

  /* ---------- chooser ---------- */
  var chEl = $('[data-plr-ch]', root), entry = $('[data-plr-entry]', root);
  var BASE = { open: false, step: 1, counter: null, cVal: 95, len: 180, lenSkip: false, walls: 0, sit: null, mat: null, a: {} };
  // generic-v1 (pillar-engine-generic-v1.md): the category's pillar.page chooser carries its own steps and rules.
  var GEN = !!(D.ch && D.ch.engine === 'generic-v1');
  var ch = Object.assign({}, BASE, store(':ch') || {}, { open: false });
  var trigger = null;
  function save() { store(':ch', ch); }

  function seatInfo(c) {
    if (c.counter === 'std') return { seat: 66, custom: false, cTxt: T.opts1[0][1], leg: T.leg_std };
    if (c.counter === 'bar') return { seat: 76, custom: false, cTxt: T.opts1[1][1], leg: T.leg_std };
    if (c.counter === 'custom') {
      var v = c.cVal;
      if (v >= 89 && v <= 92) return { seat: 66, custom: false, v: v, cTxt: cm(v), leg: cm(v - 66) };
      if (v >= 99 && v <= 102) return { seat: 76, custom: false, v: v, cTxt: cm(v), leg: cm(v - 76) };
      return { seat: v - 25, custom: true, v: v, cTxt: cm(v), leg: cm(25) };
    }
    return null;
  }
  function counts(c) {
    if (c.lenSkip) return null;
    var eff = c.len - 10 * c.walls;
    return { eff: eff, slim: Math.floor(eff / 50), std: Math.floor(eff / 55), wide: Math.floor(eff / 60) };
  }
  function reason(id, sit) { var r = D.ch.reasons[id] || {}; return r[sit] || r.def || ''; }
  function rank(c, si) {
    var ids = (D.ch.rank[c.sit || 'none'] || D.ch.rank.none).filter(function (i) { return M[i]; });
    var custom = si && si.custom;
    if (custom && c.mat === 'oak') {
      var v = si.v, near = v - 76 >= 20 ? 76 : 66;
      var steel = ids.filter(function (i) { return M[i].material === 'steel'; }).slice(0, 2).map(function (i) { return { id: i, reason: reason(i, c.sit), sub: fmt(T.sub_custom, { s: si.seat }) }; });
      var oak = ids.filter(function (i) { return M[i].material === 'oak'; })[0];
      return { conflict: true, near: near, list: steel.concat([{ id: oak, reason: fmt(T.reason_oak_near, { h: near, g: v - near }), sub: fmt(T.sub_std_near, { h: near }) }]) };
    }
    var l = ids;
    if (custom || c.mat === 'steel') l = l.filter(function (i) { return M[i].material === 'steel'; });
    if (c.mat === 'oak') l = l.filter(function (i) { return M[i].material === 'oak'; });
    // Subcollection page: prefer the models on this page; if none fit the answers, keep the full-range pick.
    if (D.allow) { var a = l.filter(function (i) { return D.allow.indexOf(i) > -1; }); if (a.length) l = a; }
    var sub = custom ? fmt(T.sub_custom, { s: si.seat }) : (si ? fmt(T.sub_seat, { s: si.seat }) : T.sub_any);
    return { conflict: false, list: l.slice(0, 3).map(function (i) { return { id: i, reason: reason(i, c.sit), sub: sub }; }) };
  }
  function result(c) {
    var si = seatInfo(c), k = counts(c), rk = rank(c, si), top = M[rk.list[0].id];
    var n = k ? Math.floor(k.eff / top.spacing) : null, s1, s2 = '', bd = [], note = null, noteLabel = '';
    if (!si) s1 = T.why_unknown;
    else if (si.custom) s1 = fmt(T.why_custom, { v: si.v, s: si.seat });
    else s1 = fmt(T.why_std, { c: si.cTxt, l: si.leg, s: si.seat });
    if (k) {
      var pre = c.walls ? fmt(c.walls === 2 ? T.why_wall2 : T.why_wall1, { e: k.eff }) : fmt(T.why_len, { L: c.len });
      s2 = k.slim === k.std ? fmt(T.why_same, { p: pre, n: k.std, u: noun(k.std) }) : fmt(T.why_diff, { p: pre, n: k.std, s: k.slim, u: noun(k.std) });
      var out = [];
      [['slim', k.slim], ['std', k.std], ['wide', k.wide]].forEach(function (g) {
        var last = out[out.length - 1];
        if (last && last.v === g[1]) last.k.push(g[0]); else out.push({ k: [g[0]], v: g[1] });
      });
      if (out.length > 1) bd = out.map(function (o) {
        var lab = o.k.map(function (w, j) { return j ? T.widths_join[w] : T.widths[w]; }).join(' ' + T.or + ' ');
        return fmt(T.breakdown, { k: lab, n: o.v, u: noun(o.v) });
      });
    }
    if (rk.conflict) {
      var leg = si.v - rk.near;
      noteLabel = T.note_tradeoff_label;
      note = fmt(T.note_tradeoff, { v: si.v, h: rk.near, g: leg, x: leg > 26 ? T.note_low : T.note_tight, s: si.seat });
    } else if (si && si.custom) { noteLabel = T.note_custom_label; note = T.note_custom; }
    else if (!si) { noteLabel = T.note_unknown_label; note = T.note_unknown; }
    return { si: si, k: k, rk: rk, n: n, why: s1 + s2, bd: bd, note: note, noteLabel: noteLabel };
  }
  window.__plrLogic = { seatInfo: seatInfo, counts: counts, rank: rank, result: result };

  var ICON_X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function opt(list, key, extraSub) {
    return '<div class="plr-ch__opts" role="radiogroup">' + list.map(function (o) {
      var sub = extraSub && extraSub[o[0]] ? extraSub[o[0]] : o[2];
      return '<button type="button" class="plr-opt" role="radio" aria-checked="' + (ch[key] === o[0]) + '" data-set="' + key + '" data-val="' + o[0] + '"><span class="plr-opt__dot"></span><span class="plr-opt__t"><span>' + esc(o[1]) + '</span><small>' + esc(sub) + '</small></span></button>';
    }).join('') + '</div>';
  }
  function head(q1, sub) { return '<div><h3 class="plr-ch__q" tabindex="-1">' + esc(q1) + '</h3><p class="plr-ch__qsub">' + esc(sub) + '</p></div>'; }
  function cvalNote() {
    var s = seatInfo(Object.assign({}, ch, { counter: 'custom' }));
    return s.custom ? fmt(T.slider_custom, { s: s.seat }) : fmt(T.slider_standard, { s: s.seat, l: s.leg });
  }
  function lenNote() {
    var k = counts(Object.assign({}, ch, { lenSkip: false }));
    return fmt(T.len_note, { n: k.std, u: noun(k.std) }) + (k.slim !== k.std ? fmt(T.len_note_slim, { s: k.slim, v: noun(k.slim) }) : '') + (ch.walls ? (ch.walls === 2 ? T.len_note_wall2 : T.len_note_wall1) : '') + '.';
  }
  function asideRows() {
    var si = seatInfo(ch), k = counts(ch);
    var v = [
      si ? cm(si.seat) : (ch.counter === 'unsure' ? T.aside_unsure : null),
      ch.step > 2 && k ? (k.slim !== k.std ? fmt(T.aside_slim, { n: k.std, s: k.slim }) : String(k.std)) : null,
      ch.sit ? T.sit_txt[ch.sit] : null,
      ch.mat ? T.mat_txt[ch.mat] : null
    ];
    return T.aside_keys.map(function (key, i) {
      return '<div class="plr-aside__row"><span>' + esc(key) + '</span><b' + (v[i] ? '' : ' class="unset"') + '>' + esc(v[i] || T.not_set) + '</b></div>';
    }).join('');
  }
  function stepHtml() {
    var s = ch.step, h = '';
    if (s === 1) {
      h += head(T.q1, T.q1_sub) + opt(T.opts1, 'counter');
      if (ch.counter === 'custom') {
        h += '<div class="plr-box"><div class="plr-box__v"><b data-cvtxt>' + esc(cm(ch.cVal)) + '</b><span>' + esc(T.to_underside) + '</span></div>' +
          '<input type="range" min="80" max="115" step="1" value="' + ch.cVal + '" aria-label="' + esc(T.slider_aria) + '" data-cval>' +
          '<div class="plr-box__ends"><span>' + cm(80) + '</span><span>' + cm(115) + '</span></div><p data-cvnote>' + esc(cvalNote()) + '</p>' +
          '<button type="button" class="plr-btn" data-next>' + esc(T.next) + '</button></div>';
      } else if (ch.counter === 'unsure') {
        h += '<div class="plr-box plr-unsure"><svg viewBox="0 0 240 150" role="img" aria-label="' + esc(T.unsure_aria) + '"><path d="M10 140H230" stroke="#8A8780" stroke-width="1" fill="none"/><rect x="60" y="26" width="160" height="10" fill="#3D3B37"/><rect x="120" y="36" width="96" height="104" fill="none" stroke="#8A8780" stroke-width="1"/><path d="M84 138V40" stroke="#262522" stroke-width="1.25" fill="none"/><path d="M80 44l4-6 4 6M80 134l4 6 4-6" stroke="#262522" stroke-width="1.25" fill="none"/><path d="M70 37H98" stroke="#262522" stroke-width="1" stroke-dasharray="2 2" fill="none"/></svg>' +
          '<div style="display:flex;flex-direction:column;gap:12px"><p>' + esc(T.unsure_text) + '</p><div class="plr-unsure__acts"><button type="button" class="plr-btn plr-btn--2" data-set="counter" data-val="custom">' + esc(T.unsure_enter) + '</button><button type="button" class="plr-textbtn" data-next>' + esc(T.unsure_skip) + '</button></div></div></div>';
      }
    } else if (s === 2) {
      h += head(T.q2, T.q2_sub) + '<div class="plr-box"><div class="plr-box__v"><b data-lentxt>' + esc(cm(ch.len)) + '</b></div>' +
        '<input type="range" min="100" max="400" step="5" value="' + ch.len + '" aria-label="' + esc(T.len_aria) + '" data-len>' +
        '<div class="plr-box__ends"><span>' + cm(100) + '</span><span>' + cm(400) + '</span></div></div>' +
        '<div style="display:flex;flex-direction:column;gap:8px"><span style="font-size:15px;color:var(--ink)">' + esc(T.walls_q) + '</span><div class="plr-seg" role="radiogroup" aria-label="' + esc(T.walls_q) + '">' +
        T.walls.map(function (w, i) { return '<button type="button" role="radio" aria-checked="' + (ch.walls === i) + '" data-walls="' + i + '">' + esc(w) + '</button>'; }).join('') + '</div></div>' +
        '<p aria-live="polite" data-lennote style="font-size:15px">' + esc(lenNote()) + '</p><button type="button" class="plr-btn" data-next>' + esc(T.next) + '</button>';
    } else if (s === 3) {
      h += head(T.q3, T.q3_sub) + opt(T.opts3, 'sit');
    } else if (s === 4) {
      var si = seatInfo(ch);
      h += head(T.q4, T.q4_sub) + opt(T.opts4, 'mat', si && si.custom ? { oak: T.oak_sub_custom } : null);
    } else {
      h += resultHtml();
    }
    return h;
  }
  // Per-model facts from the dataset (production drawings): how many of THIS model fit, its width, footrest drop.
  function fitLine(m, k) {
    var parts = [];
    if (k && m.spacing) parts.push(fmt(T.fit, { n: Math.floor(k.eff / m.spacing), L: k.eff }));
    parts.push(fmt(T.fitw, { w: m.seat }));
    if (m.foot) parts.push(fmt(T.fitf, { f: m.foot }));
    return parts.join(' · ');
  }
  function resultHtml() {
    var r = result(ch), si = r.si;
    var seatFig = si ? cm(si.seat) : cm(66);
    var seatLabel = !si ? T.seat_label_unknown : (si.custom ? T.seat_label_custom : T.seat_label);
    var h = '<div class="plr-res"><h3 class="plr-vh plr-ch__q" tabindex="-1">' + esc(T.result_label) + '</h3><div class="plr-res__figs"><div><b>' + esc(seatFig) + '</b><span>' + esc(seatLabel) + '</span></div>';
    if (r.k) h += '<div><b>' + r.n + '</b><span>' + esc(fmt(r.n === 1 ? T.count_label_one : T.count_label, { l: ch.len })) + '</span></div>';
    h += '</div><p class="plr-res__why">' + esc(r.why) + '</p>';
    if (r.bd.length > 1) h += '<div class="plr-res__bd">' + r.bd.map(function (b) { return '<span>' + esc(b) + '</span>'; }).join('') + '</div>';
    if (r.note) h += '<div class="plr-note"><span class="plr-label plr-label--ink">' + esc(r.noteLabel) + '</span><p>' + esc(r.note) + '</p></div>';
    h += '<div class="plr-res__cards">' + r.rk.list.map(function (x, i) {
      var p = PROD[x.id] || {}, m = M[x.id];
      return '<a class="plr-rcard" href="' + esc(p.url || '#shop') + '" data-rpick="' + x.id + '" data-idx="' + (i + 1) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="88" height="110" loading="lazy">' : '') +
        '<span class="plr-rcard__t"><span class="plr-label">' + esc(i === 0 ? T.best : T.also) + '</span><span class="plr-rcard__n">' + esc(fmt(U.title, { n: m.name })) + '</span><span class="plr-rcard__p">' + esc(p.price || '') + '</span>' +
        '<span class="plr-rcard__s">' + esc(x.sub) + '</span><span class="plr-rcard__r">' + esc(x.reason) + '</span>' +
        (T.fitw ? '<span class="plr-rcard__f">' + esc(fitLine(m, r.k)) + '</span>' : '') + '</span></a>';
    }).join('') + '</div>';
    h += '<div class="plr-res__links"><a href="' + esc(R + T.guide_height) + '" data-plr-guide="chooser">' + esc(T.why_height) + '</a><a href="' + esc(R + T.guide_count) + '" data-plr-guide="chooser">' + esc(T.how_many) + '</a></div>';
    h += '<div class="plr-res__acts"><button type="button" class="plr-btn" data-shopres>' + esc(fmt(T.shop, { n: r.rk.list.length })) + '</button><button type="button" class="plr-btn plr-btn--2" data-plr-samples="chooser">' + esc(T.samples) + '</button><button type="button" class="plr-textbtn" data-restart>' + esc(T.restart) + '</button></div></div>';
    ev('chooser_result', { seat: si ? si.seat : null, custom: !!(si && si.custom), count: r.n, picks: r.rk.list.map(function (x) { return x.id; }).join(','), conflict: r.rk.conflict });
    return h;
  }
  /* EVERY QUESTION CARRIES A PICTURE (Figma: chooser flow, premium pass). Step 1 the height elevation, step 2 the
     seating plan at the chosen length, step 3 backless against full back (Svea, Philip), step 4 one armrest stool
     in two materials (Carl, Bruno). The drawings are the ones the Before-you-choose tabs already render; each
     caption ADDS a fact rather than repeating the question. */
  var CAP = D.cap || [];
  function pairHtml(a, b) {
    return [a, b].filter(function (id) { return PROD[id] && (PROD[id].big || PROD[id].img); }).map(function (id) {
      return '<span class="plr-ch__pic"><img src="' + esc(PROD[id].big || PROD[id].img) + '" alt="' + esc(fmt(U.title, { n: (M[id] || {}).name || id })) + '" width="300" height="375" loading="lazy" decoding="async"><small>' + esc((M[id] || {}).name || '') + '</small></span>';
    }).join('');
  }
  function mediaHtml(s) {
    var art = '';
    if (s === 1) { var hs = $('[data-plr-sketch="height"]', root); art = hs ? hs.outerHTML : ''; }
    else if (s === 2) { var cs = $('[data-plr-csvg]', root); art = cs ? cs.outerHTML : ''; }
    else if (s === 3) art = '<span class="plr-ch__pair">' + pairHtml('svea', 'philip') + '</span>';
    else if (s === 4) art = '<span class="plr-ch__pair">' + pairHtml('carl', 'bruno') + '</span>';
    if (!art) return '';
    return '<figure class="plr-ch__media" aria-hidden="true"><span class="plr-ch__art">' + art + '</span>' + (CAP[s - 1] ? '<figcaption>' + esc(inch(CAP[s - 1])) + '</figcaption>' : '') + '</figure>';
  }
  function chPlan() { var g = $('.plr-ch__media [data-plr-cplan]', chEl); if (!g) return; var keep = cplan; cplan = g; drawPlan(ch.len); cplan = keep; }
  function render(focus) {
    var s = ch.step, mob = MOB.matches, NS = GEN ? gVis().length : 4;
    var bars = Array.apply(null, Array(NS)).map(function (_, i) { return i + 1; }).map(function (i) { return '<span' + (i <= s ? ' class="on"' : '') + '></span>'; }).join('');
    /* Head (label, step, close, a progress bar across the full width), then the columns (picture, question, the
       fit so far), then Back and Skip pinned on a hairline whatever the step above is doing. */
    var head = '<div class="plr-ch__head"><span class="plr-ch__handle" aria-hidden="true"></span>' +
      '<div class="plr-ch__top"><div><span class="plr-label plr-label--ink">' + esc(T.label) + '</span><span class="plr-label">' + esc(s <= NS ? fmt(T.step, { n: s }) : T.result_label) + '</span></div>' +
      '<button type="button" class="plr-ch__close" data-close aria-label="' + esc(T.close) + '">' + ICON_X + '</button></div>' +
      '<div class="plr-ch__bars" aria-hidden="true">' + bars + '</div></div>';
    var main = '<div class="plr-ch__main">' + stepHtml() + '</div>';
    var media = s <= NS ? mediaHtml(s) : '';
    var aside = !mob && s <= NS ? '<aside class="plr-aside" aria-live="polite"><span class="plr-label">' + esc(T.aside_h) + '</span><div data-aside>' + asideRows() + '</div><p>' + esc(T.aside_foot) + '</p></aside>' : '';
    var nav = s <= NS ? '<div class="plr-ch__nav"><button type="button" data-back' + (s === 1 ? ' disabled' : '') + '>' + esc(T.back) + '</button><button type="button" data-skip>' + esc(T.skip) + '</button></div>' : '';
    chEl.innerHTML = '<div class="plr-ch__scrim" data-scrim><div class="plr-ch__sheet" role="dialog" aria-label="' + esc(T.label) + '"' + (mob ? ' aria-modal="true"' : '') + '>' +
      head + '<div class="plr-ch__cols' + (media ? '' : ' plr-ch__cols--nomedia') + '">' + media + main + aside + '</div>' + nav + '</div></div>';
    if (s === 2 && !GEN) chPlan();
    chEl.classList.toggle('plr-ch--result', s > NS);
    if (focus !== false) { var hq = $('.plr-ch__q', chEl); if (hq) hq.focus({ preventScroll: !mob }); }
    save();
  }

  /* ---------- generic-v1 chooser: every string from D.ch.t, every rule from D.ch.rules (no category logic here) ---------- */
  function gVis() {
    return (D.ch.steps || []).filter(function (st) {
      if (!st.when) return true;
      return Object.keys(st.when).every(function (k) { return ch.a[k] === st.when[k]; });
    });
  }
  function gStep() { return gVis()[ch.step - 1]; }
  function gVal(st) { var v = ch.a[st.id]; return v == null && st.type === 'slider' ? st.value : v; }
  function gLabel(st) {
    var v = ch.a[st.id]; if (v == null) return null;
    if (st.type === 'slider') return cm(+v);
    var o = (st.opts || []).filter(function (x) { return x[0] === v; })[0];
    return o ? o[1] : v;
  }
  function gOpt(st) {
    return '<div class="plr-ch__opts" role="radiogroup">' + st.opts.map(function (o) {
      return '<button type="button" class="plr-opt" role="radio" aria-checked="' + (ch.a[st.id] === o[0]) + '" data-gset="' + esc(st.id) + '" data-val="' + esc(o[0]) + '"><span class="plr-opt__dot"></span><span class="plr-opt__t"><span>' + esc(o[1]) + '</span><small>' + esc(o[2] || '') + '</small></span></button>';
    }).join('') + '</div>';
  }
  function gStepHtml() {
    var st = gStep();
    if (!st) return gResultHtml();
    var h = head(st.q, st.sub || '');
    if (st.type === 'slider') {
      var v = gVal(st);
      h += '<div class="plr-box"><div class="plr-box__v"><b data-gstxt>' + esc(cm(+v)) + '</b></div>' +
        '<input type="range" min="' + st.min + '" max="' + st.max + '" step="' + st.step + '" value="' + v + '" aria-label="' + esc(st.q) + '" data-gslider="' + esc(st.id) + '">' +
        '<div class="plr-box__ends"><span>' + cm(st.min) + '</span><span>' + cm(st.max) + '</span></div></div>' +
        '<button type="button" class="plr-btn" data-gnext>' + esc(T.next) + '</button>';
    } else h += gOpt(st);
    return h;
  }
  function gAside() {
    return gVis().map(function (st) {
      var v = gLabel(st);
      return '<div class="plr-aside__row"><span>' + esc(st.q) + '</span><b' + (v ? '' : ' class="unset"') + '>' + esc(v || T.not_set) + '</b></div>';
    }).join('');
  }
  function gResult() {
    var R_ = D.ch.rules || {}, ids = Object.keys(M), fit = null, cnt = null, note = null;
    if (R_.fit) {
      var f = R_.fit, raw = ch.a[f.answer], tv = (raw == null || raw === 'unsure' || isNaN(+raw)) ? f.assume : +raw;
      fit = { t: tv, a: tv - f.gap_max, b: tv - f.gap_min, ok: function (id) { var g = tv - (+M[id][f.model_field]); return g >= f.gap_min && g <= f.gap_max; } };
    }
    if (R_.count) {
      var c = R_.count, roundN = null, roundKey = null;
      Object.keys(c.round || {}).forEach(function (k) { gVis().forEach(function (st) { if (ch.a[st.id] === k) { roundN = c.round[k]; roundKey = k; } }); });
      var lenSt = gVis().filter(function (st) { return st.id === c.answer; })[0];
      if (roundN != null) cnt = { round: true, n: roundN, d: +(String(roundKey).replace(/\D+/g, '')) || '' };
      else if (lenSt) {
        var L = +gVal(lenSt), sp = ids.map(function (id) { return +M[id][c.per_chair_field]; }).filter(function (x) { return x > 0; });
        if (sp.length) cnt = { round: false, L: L, n: 2 * Math.floor(L / Math.min.apply(null, sp)), m: 2 * Math.floor(L / Math.max.apply(null, sp)) };
      }
    }
    var rk = R_.rank || {}, ans = ch.a[rk.answer], lists = rk.lists || {};
    var list = (lists[ans] || lists[Object.keys(lists)[0]] || ids).filter(function (id) { return M[id]; });
    [rk.filter, rk.filter2].forEach(function (fl) {
      if (!fl) return;
      var fv = ch.a[fl.answer];
      if (fv && fv !== (fl.any || 'any')) { var kept = list.filter(function (id) { return M[id][fl.field] === fv; }); if (kept.length) list = kept; }
    });
    if (D.allow) { var al = list.filter(function (i) { return D.allow.indexOf(i) > -1; }); if (al.length) list = al; }
    if (fit) {
      var fitting = list.filter(fit.ok);
      if (fitting.length) list = fitting;
      else {
        var f2 = R_.fit, mid = (f2.gap_min + f2.gap_max) / 2;
        list = list.slice().sort(function (x, y) { return Math.abs(fit.t - M[x][f2.model_field] - mid) - Math.abs(fit.t - M[y][f2.model_field] - mid); }).slice(0, 1);
        note = T.none_fit;
      }
    }
    list = list.slice(0, R_.limit || 3).map(function (id) { var r = D.ch.reasons && D.ch.reasons[id] || {}; return { id: id, reason: r[ans] || r.def || '', sub: '' }; });
    var why = (fit ? fmt(T.why_fit, { t: fit.t, a: fit.a, b: fit.b }) : '') + (cnt ? ' ' + (cnt.round ? fmt(T.why_round, { d: cnt.d, n: cnt.n }) : fmt(T.why_count, { L: cnt.L, n: cnt.n, m: cnt.m })) : '');
    return { fit: fit, cnt: cnt, note: note, why: why.trim(), rk: { list: list, conflict: false } };
  }
  function gResultHtml() {
    var r = gResult();
    var h = '<div class="plr-res"><h3 class="plr-vh plr-ch__q" tabindex="-1">' + esc(T.result_label) + '</h3><div class="plr-res__figs">';
    if (r.fit) h += '<div><b>' + esc((IN ? toIn(r.fit.a) : r.fit.a) + '–' + cm(r.fit.b)) + '</b><span>' + esc(T.seat_label || '') + '</span></div>';
    if (r.cnt) h += '<div><b>' + r.cnt.n + '</b><span>' + esc(r.cnt.round ? '' : fmt(T.count_label || '', { l: r.cnt.L })) + '</span></div>';
    h += '</div>' + (r.why ? '<p class="plr-res__why">' + esc(r.why) + '</p>' : '');
    if (r.cnt && !r.cnt.round && T.count_note) h += '<p class="plr-res__bd"><span>' + esc(T.count_note) + '</span></p>';
    if (r.note) h += '<div class="plr-note"><p>' + esc(r.note) + '</p></div>';
    h += '<div class="plr-res__cards">' + r.rk.list.map(function (x, i) {
      var p = PROD[x.id] || {}, m = M[x.id];
      return '<a class="plr-rcard" href="' + esc(p.url || '#shop') + '" data-rpick="' + x.id + '" data-idx="' + (i + 1) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="88" height="110" loading="lazy">' : '') +
        '<span class="plr-rcard__t"><span class="plr-label">' + esc(i === 0 ? T.best : T.also) + '</span><span class="plr-rcard__n">' + esc(fmt(U.title, { n: m.name })) + '</span><span class="plr-rcard__p">' + esc(p.price || '') + '</span>' +
        '<span class="plr-rcard__r">' + esc(x.reason) + '</span></span></a>';
    }).join('') + '</div>';
    var links = [];
    if (T.guide_height && T.why_height) links.push('<a href="' + esc(R + T.guide_height) + '" data-plr-guide="chooser">' + esc(T.why_height) + '</a>');
    if (T.guide_count && T.how_many) links.push('<a href="' + esc(R + T.guide_count) + '" data-plr-guide="chooser">' + esc(T.how_many) + '</a>');
    if (links.length) h += '<div class="plr-res__links">' + links.join('') + '</div>';
    h += '<div class="plr-res__acts"><button type="button" class="plr-btn" data-shopres>' + esc(fmt(T.shop, { n: r.rk.list.length })) + '</button>' + (T.samples ? '<button type="button" class="plr-btn plr-btn--2" data-plr-samples="chooser">' + esc(T.samples) + '</button>' : '') + '<button type="button" class="plr-textbtn" data-restart>' + esc(T.restart) + '</button></div></div>';
    ev('chooser_result', { engine: 'generic-v1', picks: r.rk.list.map(function (x) { return x.id; }).join(','), count: r.cnt ? r.cnt.n : null });
    return h;
  }
  function gMedia(s) { var st = gVis()[s - 1]; return st && st.img ? '<figure class="plr-ch__media" aria-hidden="true"><span class="plr-ch__art"><img src="' + esc(st.img) + '" alt="" loading="lazy"></span></figure>' : ''; }
  if (GEN) { stepHtml = gStepHtml; asideRows = gAside; result = gResult; mediaHtml = gMedia; }
  function gClick(b) {
    if (b.hasAttribute('data-gset')) {
      ch.a[b.dataset.gset] = b.dataset.val;
      ev('chooser_step', { step: ch.step, value: b.dataset.val, skipped: false });
      render(false); advance(ch.step + 1); return true;
    }
    if (b.hasAttribute('data-gnext')) { var st = gStep(); if (st && ch.a[st.id] == null) ch.a[st.id] = st.value; ev('chooser_step', { step: ch.step, value: st && ch.a[st.id], skipped: false }); setCh({ step: ch.step + 1 }); return true; }
    if (b.hasAttribute('data-skip')) { var s2 = gStep(); ev('chooser_step', { step: ch.step, skipped: true }); if (s2 && s2.type !== 'slider') delete ch.a[s2.id]; setCh({ step: ch.step + 1 }); return true; }
    if (b.hasAttribute('data-restart')) { ch = Object.assign({}, BASE, { open: true, a: {} }); render(); return true; }
    return false;
  }
  function setCh(o, focus) { Object.assign(ch, o); render(focus); }
  function openChooser(o, src) {
    trigger = document.activeElement;
    Object.assign(ch, o || {}, { open: true });
    chEl.hidden = false;
    entry.hidden = !MOB.matches;
    if (MOB.matches) document.documentElement.style.overflow = 'hidden';
    render();
    if (!MOB.matches) scrollToEl($('#find'));
    ev('chooser_open', { source: src || 'entry', step: ch.step });
    updSticky();
  }
  function closeChooser() {
    if (!ch.open) return;
    ch.open = false; chEl.hidden = true; entry.hidden = false; chEl.innerHTML = '';
    document.documentElement.style.overflow = '';
    save(); updSticky();
    if (trigger && trigger.focus) trigger.focus({ preventScroll: true });
  }
  function advance(to) { setTimeout(function () { setCh({ step: to }); }, 220); }
  if (chEl) chEl.addEventListener('click', function (e) {
    var t = e.target;
    if (t.matches('[data-scrim]') && MOB.matches) return closeChooser();
    var b = t.closest('button');
    if (!b) { var ra = t.closest('[data-rpick]'); if (ra) ev('select_item', { item_id: ra.dataset.rpick, index: +ra.dataset.idx, list: 'chooser' }); return; }
    if (b.hasAttribute('data-close')) return closeChooser();
    if (GEN && gClick(b)) return;
    if (b.hasAttribute('data-set')) {
      var key = b.dataset.set, val = b.dataset.val, o = {}; o[key] = val;
      ev('chooser_step', { step: ch.step, value: val, skipped: false });
      if (key === 'counter') { setCh(o, val === 'custom' || val === 'unsure' ? false : undefined); if (val === 'std' || val === 'bar') advance(2); else { var inp = $('[data-cval]', chEl) || $('.plr-unsure button', chEl); if (inp) inp.focus(); } }
      else { setCh(o, false); advance(ch.step + 1); }
      return;
    }
    if (b.hasAttribute('data-walls')) { ch.walls = +b.dataset.walls; $$('[data-walls]', chEl).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); }); $('[data-lennote]', chEl).textContent = lenNote(); save(); return; }
    if (b.hasAttribute('data-next')) { ev('chooser_step', { step: ch.step, value: ch.step === 2 ? ch.len : ch.cVal, skipped: false }); return setCh({ step: Math.min(5, ch.step + 1), lenSkip: ch.step === 2 ? false : ch.lenSkip }); }
    if (b.hasAttribute('data-back')) return setCh({ step: Math.max(1, ch.step - 1) });
    if (b.hasAttribute('data-skip')) {
      ev('chooser_step', { step: ch.step, skipped: true });
      if (ch.step === 1) return setCh({ counter: null, step: 2 });
      if (ch.step === 2) return setCh({ lenSkip: true, step: 3 });
      if (ch.step === 3) return setCh({ sit: null, step: 4 });
      return setCh({ mat: 'any', step: 5 });
    }
    if (b.hasAttribute('data-restart')) { ch = Object.assign({}, BASE, { open: true }); return render(); }
    if (b.hasAttribute('data-shopres')) {
      matches = result(ch).rk.list.map(function (x) { return x.id; });
      store(':matches', matches);
      ev('chooser_shop', { n: matches.length });
      closeChooser(); showMatchChip(); setFilter('match'); scrollToEl($('#shop'));
    }
  });
  if (chEl) chEl.addEventListener('input', function (e) {
    var t = e.target;
    if (GEN && t.matches('[data-gslider]')) { ch.a[t.dataset.gslider] = +t.value; var gt = $('[data-gstxt]', chEl); if (gt) gt.textContent = cm(+t.value); var ga = $('[data-aside]', chEl); if (ga) ga.innerHTML = gAside(); save(); return; }
    if (t.matches('[data-cval]')) { ch.cVal = +t.value; $('[data-cvtxt]', chEl).textContent = cm(ch.cVal); $('[data-cvnote]', chEl).textContent = cvalNote(); }
    if (t.matches('[data-len]')) { ch.len = +t.value; $('[data-lentxt]', chEl).textContent = cm(ch.len); $('[data-lennote]', chEl).textContent = lenNote(); chPlan(); }
    var a = $('[data-aside]', chEl); if (a) a.innerHTML = asideRows();
    save();
  });
  if (chEl) chEl.addEventListener('keydown', function (e) { trap(e, $('.plr-ch__sheet', chEl), MOB.matches, closeChooser); });
  $$('[data-plr-entry-opt]', root).forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var v = a.getAttribute('data-plr-entry-opt');
      if (GEN) { var first = (D.ch.steps || [])[0], aa = {}; if (first) aa[first.id] = v; return openChooser({ a: aa, step: 2 }, 'entry'); }
      openChooser({ counter: v, step: v === 'std' || v === 'bar' ? 2 : 1 }, 'entry');
    });
  });
  $$('[data-plr-find]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var src = a.getAttribute('data-plr-find');
      if (src === 'hero') ev('pillar_hero_cta', { cta: 'find' });
      if (!MOB.matches) scrollToEl($('#find'));
      openChooser({ step: ch.step }, src);
    });
  });
  MOB.addEventListener && MOB.addEventListener('change', function () { if (ch.open) { entry.hidden = !MOB.matches; document.documentElement.style.overflow = MOB.matches ? 'hidden' : ''; render(false); } });
  if (q.get('find')) openChooser({ step: Math.max(1, +q.get('find') || 1) }, 'link');

  /* Focus trap for modal surfaces; Esc closes. */
  function trap(e, box, modal, close) {
    if (e.key === 'Escape') { close(); return; }
    if (!modal || e.key !== 'Tab' || !box) return;
    var f = $$('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- before you choose: tabbed guide ---------- */
  var kn = $('[data-plr-kn]', root), ktabs = kn ? $$('[data-plr-ktab]', kn) : [];
  function kTab(id, focus, src) {
    ktabs.forEach(function (t) {
      var on = t.getAttribute('data-plr-ktab') === id;
      t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
      if (on && MOB.matches) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    $$('.plr-kn__panel', kn).forEach(function (p) { p.classList.toggle('is-active', p.id === id); });
    if (src) ev('know_tab', { anchor: id, source: src });
  }
  ktabs.forEach(function (t, i) {
    t.addEventListener('click', function () { kTab(t.getAttribute('data-plr-ktab'), false, 'click'); });
    t.addEventListener('keydown', function (e) {
      var d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
      if (!d) return; e.preventDefault();
      kTab(ktabs[(i + d + ktabs.length) % ktabs.length].getAttribute('data-plr-ktab'), true, 'key');
    });
  });
  if (kn) kn.addEventListener('click', function (e) {
    var a = e.target.closest('[data-plr-act]'); if (!a) return;
    var act = a.getAttribute('data-plr-act').split(':');
    if (act[0] === 'chooser') { if (!MOB.matches) scrollToEl($('#find')); openChooser({ step: +act[1] }, 'know'); }
    if (act[0] === 'filter') { setFilter(act[1]); scrollToEl($('#shop')); }
  });
  /* ---------- pencil sketch renderer: overshooting double strokes, construction lines, loose hatching ---------- */
  function rng(seed) { return function () { seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function f1(v) { return Math.round(v * 10) / 10; }
  var VE = ' vector-effect="non-scaling-stroke"';
  /* Architect drafting: one confident stroke per edge (a faint second pass only where asked), a small
     overshoot at the corners, hairline datum lines, dimension lines with 45-degree ticks, fine hatching. */
  function skLine(R, x1, y1, x2, y2, o) {
    o = o || {};
    var dx = x2 - x1, dy = y2 - y1, len = Math.hypot(dx, dy) || 1, ux = dx / len, uy = dy / len, nx = -uy, ny = ux, out = '';
    var over = o.over == null ? 3.5 : o.over, w = o.w || .9, op = o.op == null ? .92 : o.op;
    for (var p = 0; p < (o.double ? 2 : 1); p++) {
      var o1 = over * (.6 + R() * .7), o2 = over * (.6 + R() * .7), j = p ? .7 : .25;
      var ax = x1 - ux * o1 + nx * (R() - .5) * j, ay = y1 - uy * o1 + ny * (R() - .5) * j;
      var bx = x2 + ux * o2 + nx * (R() - .5) * j, by = y2 + uy * o2 + ny * (R() - .5) * j;
      var bow = (R() - .5) * (p ? .6 : .35), mx = (ax + bx) / 2 + nx * bow, my = (ay + by) / 2 + ny * bow;
      out += '<path d="M' + f1(ax) + ' ' + f1(ay) + 'Q' + f1(mx) + ' ' + f1(my) + ' ' + f1(bx) + ' ' + f1(by) + '" stroke-width="' + (p ? w * .5 : w) + '" opacity="' + (p ? op * .35 : op) + '"' + VE + '/>';
    }
    return out;
  }
  function datum(x1, y1, x2, y2) { return '<path d="M' + x1 + ' ' + y1 + 'L' + x2 + ' ' + y2 + '" stroke-width=".3" opacity=".22"' + VE + '/>'; }
  function tick(x, y) { return '<path d="M' + f1(x - 2.6) + ' ' + f1(y + 2.6) + 'L' + f1(x + 2.6) + ' ' + f1(y - 2.6) + '" stroke-width=".9" opacity=".85"' + VE + '/>'; }
  function dimV(R, x, y1, y2) { return skLine(R, x, y1, x, y2, { w: .5, op: .7, over: 1.5 }) + tick(x, y1) + tick(x, y2); }
  function dimH(R, x1, x2, y) { return skLine(R, x1, y, x2, y, { w: .5, op: .7, over: 1.5 }) + tick(x1, y) + tick(x2, y); }
  function skRect(R, x0, y0, x1, y1, o) {
    return skLine(R, x0, y0, x1, y0, o) + skLine(R, x1, y0, x1, y1, o) + skLine(R, x1, y1, x0, y1, o) + skLine(R, x0, y1, x0, y0, o);
  }
  function skHatch(R, x0, y0, x1, y1, gap, op) {
    var out = '', h = y1 - y0;
    for (var s = -h + gap / 2; s < x1 - x0; s += gap) {
      var ax = x0 + s, ay = y1, bx = x0 + s + h, by = y0;
      if (ax < x0) { ay -= (x0 - ax); ax = x0; }
      if (bx > x1) { by += (bx - x1); bx = x1; }
      if (bx - ax < 1) continue;
      out += '<path d="M' + f1(ax) + ' ' + f1(ay) + 'L' + f1(bx) + ' ' + f1(by) + '" stroke-width=".3" opacity="' + (op || .4) + '"' + VE + '/>';
    }
    return out;
  }
  /* Marker wash: broad parallel streaks along the long side, slightly off the ink lines. */
  function marker(R, x0, y0, x1, y1, color, op, dir) {
    /* One translucent, slightly irregular shape a little off the ink, plus a few faint streaks for texture. */
    var horiz = dir ? dir === 'h' : (x1 - x0) >= (y1 - y0), ox = .8 + R() * 1.6, oy = .6 + R() * 1.2;
    var j = function (v) { return f1(v + (R() - .5) * 2.2); };
    var d = 'M' + j(x0 + ox) + ' ' + j(y0 + oy) + 'L' + j(x1 + ox - R() * 3) + ' ' + j(y0 + oy) + 'L' + j(x1 + ox - R() * 2) + ' ' + j(y1 + oy) + 'L' + j(x0 + ox + R() * 2) + ' ' + j(y1 + oy) + 'Z';
    var out = '<path d="' + d + '" fill="' + color + '" stroke="none" opacity="' + op + '"/>';
    var n = 4, i;
    for (i = 0; i < n; i++) {
      if (horiz) { var y = y0 + (y1 - y0) * (i + .5) / n + oy; out += '<path d="M' + j(x0 + ox + 2) + ' ' + f1(y) + 'L' + j(x1 + ox - 4) + ' ' + f1(y + (R() - .5)) + '" stroke="' + color + '" stroke-width="' + f1(Math.max(1.2, (y1 - y0) / n * .5)) + '" opacity="' + f1(op * 35) / 100 + '" stroke-linecap="butt"/>'; }
      else { var x = x0 + (x1 - x0) * (i + .5) / n + ox; out += '<path d="M' + f1(x) + ' ' + j(y0 + oy + 2) + 'L' + f1(x + (R() - .5)) + ' ' + j(y1 + oy - 4) + '" stroke="' + color + '" stroke-width="' + f1(Math.max(1.2, (x1 - x0) / n * .5)) + '" opacity="' + f1(op * 35) / 100 + '" stroke-linecap="butt"/>'; }
    }
    return '<g style="mix-blend-mode:multiply">' + out + '</g>';
  }
  var MK = { stone: '#C9BFB1', leather: '#4B4845', oak: '#C49A6C', floor: '#D8CDBD' };
  function sketchHeight(svg) {
    var g = function (k) { return $('[data-sk="' + k + '"]', svg); }, R;
    R = rng(11); g('floor').innerHTML = marker(R, 20, 236, 320, 243, MK.oak, .28, 'h') + skLine(R, 10, 236, 330, 236, { w: .9, over: 4 }) + datum(4, 236, 336, 236);
    var slats = ''; for (var sx = 224; sx < 318; sx += 7.5) slats += '<path d="M' + sx + ' 60V232" stroke-width=".35" opacity=".28"' + VE + '/>';
    R = rng(12); g('cab').innerHTML = marker(R, 216, 56, 322, 236, MK.stone, .35, 'v') + slats + skLine(R, 216, 56, 216, 236, { w: .9, op: .85, over: 4 }) + skLine(R, 322, 56, 322, 236, { w: .9, op: .85, over: 4 });
    R = rng(13); g('dim').innerHTML = dimV(R, 44, 96, 236);
    R = rng(14); g('legs').innerHTML = skLine(R, 70, 106, 70, 236, { w: 1.1, over: 4 }) + skLine(R, 150, 106, 150, 236, { w: 1.1, over: 4 });
    R = rng(15); g('runner').innerHTML = skLine(R, 70, 233, 150, 233, { w: 1, over: 4 });
    R = rng(16); g('top').innerHTML = marker(R, 140, 48, 332, 56, MK.stone, .7, 'h') + skRect(R, 140, 48, 332, 56, { w: 1, over: 5 }) + skHatch(R, 140, 48, 332, 56, 3.2, .3) + datum(24, 56, 336, 56);
    R = rng(17); g('stool').innerHTML = skLine(R, 70, 68, 70, 107, { w: 1 }) + skLine(R, 70, 105.5, 151, 105.5, { w: .8 }) +
      marker(R, 70.5, 96, 151, 103.5, MK.leather, .55, 'h') + skRect(R, 70.5, 96, 151, 103.5, { w: 1, over: 4 }) +
      datum(24, 96, 200, 96) + dimV(R, 160, 56, 96);
  }
  var cplan = null;
  function drawPlan(L) {
    if (!cplan) return;
    var W = Math.round(L * 300 / 360), x0 = Math.round((340 - W) / 2), nS = Math.floor(L / 55), R = rng(21), h = '';
    h += marker(R, x0, 36, x0 + W, 108, MK.stone, .55, 'h') + skRect(R, x0, 36, x0 + W, 108, { w: 1, over: 6 });
    h += datum(x0 - 20, 36, x0 + W + 20, 36) + datum(x0, 24, x0, 176) + datum(x0 + W, 24, x0 + W, 176);
    for (var i = 0; i < nS; i++) {
      var cx = x0 + (i + .5) * W / nS, Ri = rng(40 + i);
      h += marker(Ri, cx - 15, 118, cx + 15, 146, MK.leather, .5, 'v') + skRect(Ri, cx - 15, 118, cx + 15, 146, { w: .95, over: 3.5 });
    }
    h += dimH(R, x0, x0 + W, 166);
    cplan.innerHTML = h;
  }
  $$('[data-plr-sketch="height"]', root).forEach(sketchHeight);

  var hcard = $('[data-plr-hcard]', root);
  if (hcard) $$('[data-plr-hmode]', hcard).forEach(function (b) {
    b.addEventListener('click', function () {
      var bar = b.dataset.plrHmode === 'bar', mode = bar ? 'bar' : 'island';
      hcard.classList.toggle('is-bar', bar);
      $$('[data-plr-hmode]', hcard).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
      $$('[data-plr-hfig]', hcard).forEach(function (x) { x.textContent = x.getAttribute('data-' + mode); });
      var st = $('[data-plr-hst]', hcard); st.textContent = st.getAttribute('data-' + mode);
      var sv = $('.plr-hsvg', hcard); sv.setAttribute('aria-label', sv.getAttribute('data-aria-' + mode));
      ev('know_interact', { anchor: 'height', value: mode });
    });
  });
  var ccard = $('[data-plr-ccard]', root), KC = (D.know && D.know.count) || {};
  if (ccard) {
  cplan = $('[data-plr-cplan]', ccard); drawPlan(+$('[data-plr-cslider]', ccard).value);
  $('[data-plr-cslider]', ccard).addEventListener('input', function (e) {
    var L = +e.target.value, W = Math.round(L * 300 / 360), x0 = Math.round((340 - W) / 2), nS = Math.floor(L / 55), nL = Math.floor(L / 50);
    drawPlan(L);
    $('[data-plr-clen]', ccard).textContent = cm(L);
    $('[data-plr-cst]', ccard).textContent = fmt(nS === 1 ? KC.statement_one : KC.statement, { n: nS, l: L });
    $('[data-plr-cline]', ccard).textContent = nL > nS ? fmt(KC.line_more, { s: nL }) : KC.line_same;
    $('[data-plr-csvg]', ccard).setAttribute('aria-label', fmt(KC.aria, { l: L, n: nS }));
  });
  $('[data-plr-cslider]', ccard).addEventListener('change', function (e) { ev('know_interact', { anchor: 'how-many', value: +e.target.value }); });
  }

  var openDet = null, detTrigger = null;
  function openDetail(id, from) {
    var d = $('[data-plr-detail="' + id + '"]', root);
    if (!d) return;
    closeDetail();
    detTrigger = from || document.activeElement;
    d.classList.add('is-open'); openDet = d;
    document.documentElement.style.overflow = 'hidden';
    $('.plr-det__panel', d).focus();
    if (id === 'tp') loadTrustpilot(d);
    ev('know_detail_open', { anchor: id });
    updSticky();
  }
  // Official Trustpilot bootstrap, once per page (same id as the PDP loader, so never twice).
  function loadTrustpilot(d) {
    var el = $('.trustpilot-widget', d);
    if (!el || el.getAttribute('data-plr-tp-done')) return;
    function render() {
      if (!(window.Trustpilot && window.Trustpilot.loadFromElement)) return false;
      try { window.Trustpilot.loadFromElement(el, true); el.setAttribute('data-plr-tp-done', '1'); } catch (e) {}
      return true;
    }
    if (render()) return;
    if (!document.getElementById('tp-bootstrap-script')) {
      var sc = document.createElement('script');
      sc.id = 'tp-bootstrap-script'; sc.async = true;
      sc.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      document.head.appendChild(sc);
    }
    var tries = 0;
    (function retry() { if (render()) return; if (tries++ < 60) setTimeout(retry, 250); })();
  }
  function closeDetail() {
    if (!openDet) return;
    openDet.classList.remove('is-open'); openDet = null;
    document.documentElement.style.overflow = '';
    if (detTrigger && detTrigger.focus) detTrigger.focus({ preventScroll: true });
    updSticky();
  }
  $$('[data-plr-det]', root).forEach(function (b) { b.addEventListener('click', function () { openDetail(b.getAttribute('data-plr-det'), b); }); });
  $$('[data-plr-detail]', root).forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-plr-close]')) return closeDetail();
      var a = e.target.closest('[data-plr-act]');
      if (!a) return;
      var act = a.getAttribute('data-plr-act').split(':');
      detTrigger = null; closeDetail();
      if (act[0] === 'chooser') { if (!MOB.matches) scrollToEl($('#find')); openChooser({ step: +act[1] }, 'module'); }
      if (act[0] === 'filter') { setFilter(act[1]); scrollToEl($('#shop')); }
    });
    d.addEventListener('keydown', function (e) { trap(e, $('.plr-det__panel', d), true, closeDetail); });
  });
  function fromHash() {
    if (!kn) return;
    var id = q.get('detail') || location.hash.slice(1);
    if (!$('[data-plr-ktab="' + id + '"]', kn)) return;
    kTab(id, false, 'link'); scrollToEl($('#know'));
  }
  window.addEventListener('hashchange', fromHash);
  fromHash();

  /* ---------- shipping calculator: checkout's own weight bands, in the visitor's currency ---------- */
  var shipEl = $('[data-plr-ship]', root), SH = D.ship;
  if (shipEl && SH && SH.zones) {
    var country = shipEl.getAttribute('data-country'), zone = null;
    SH.zones.forEach(function (z) { if (z.countries.indexOf(country) > -1) zone = z; });
    var cur = (window.Shopify && Shopify.currency) || {}, active = cur.active, rate = parseFloat(cur.rate) || 1;
    var convertible = zone && (zone.currency === active || zone.currency === 'EUR');
    if (convertible) {
      var n = 2, sel = $('[data-plr-ship-model]', shipEl), out = $('[data-plr-ship-price]', shipEl), nEl = $('[data-plr-ship-n]', shipEl);
      var fmtMoney = function (v) {
        var whole = Math.abs(v - Math.round(v)) < .005;
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: active, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v); }
        catch (e) { return v.toFixed(2) + ' ' + active; }
      };
      var calc = function () {
        var kg = (SH.weights[sel.value] || 7) * n, price = null;
        for (var i = 0; i < zone.bands.length; i++) { var b = zone.bands[i]; if (b[0] === null || kg <= b[0] + 1e-9) { price = b[1]; break; } }
        if (price === null) return;
        var shopCur = SH.shop_currency || 'EUR', about = zone.currency !== shopCur, v;
        if (zone.currency === active && !about) v = price;
        else if (zone.currency === active) v = Math.round(price * (SH.fx_fee || 1) * 100) / 100;   /* checkout converts via EUR */
        else v = Math.round(price * rate * 100) / 100;                                                 /* EUR zone in another currency: exact */
        var note = $('.plr-ship__note', shipEl);
        nEl.textContent = n;
        out.textContent = about ? note.getAttribute('data-about-fmt').replace('%p', fmtMoney(v)) : fmtMoney(v);
        note.textContent = about ? note.getAttribute('data-about') : note.getAttribute('data-exact');
      };
      sel.addEventListener('change', calc);
      $$('[data-plr-ship-step]', shipEl).forEach(function (b) { b.addEventListener('click', function () { n = Math.min(12, Math.max(1, n + +b.getAttribute('data-plr-ship-step'))); calc(); }); });
      calc(); shipEl.hidden = false;
    }
  }

  /* ---------- compare pickers ---------- */
  var cmp = $('[data-plr-cmp]', root);
  if (cmp) {
    var table = $('table', cmp), rows = $$('tr', table).filter(function (tr) { return tr.querySelector('[data-col]'); });
    var all = $$('thead th', table).map(function (th) { return th.dataset.col; });
    // Each <select> ships with its own model only; fill the full list once, client side.
    $$('select[data-plr-pick]', table).forEach(function (s) {
      var cur = s.value;
      s.innerHTML = all.map(function (id) { return '<option value="' + id + '">' + esc(M[id] ? M[id].name : id) + '</option>'; }).join('');
      s.value = cur;
    });
    var sel = (store(':cmp') || all.slice(0, 4)).filter(function (id) { return all.indexOf(id) > -1; });
    if (sel.length < 4) sel = all.slice(0, 4);
    var applyCmp = function () {
      var order = sel.concat(all.filter(function (id) { return sel.indexOf(id) < 0; }));
      rows.forEach(function (tr) {
        order.forEach(function (id, i) {
          var cell = $('[data-col="' + id + '"]', tr);
          cell.classList.toggle('is-m', i < 2); cell.classList.toggle('is-d', i < 4);
          // A picture moved into view by the picker must load now: iOS left the lazy ones blank (iPhone SE, 2026-10-31).
          var im = i < 4 && cell.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager';
          tr.appendChild(cell);
        });
      });
      $$('select', table).forEach(function (s) { s.value = s.closest('th').dataset.col; });
      store(':cmp', sel);
    };
    table.addEventListener('change', function (e) {
      var s = e.target; if (!s.matches('[data-plr-pick]')) return;
      var from = s.closest('th').dataset.col, i = sel.indexOf(from), v = s.value, j = sel.indexOf(v);
      if (i < 0) return;
      if (j > -1) sel[j] = sel[i];
      sel[i] = v;
      applyCmp();
      ev('compare_pick', { column: i + 1, model: v });
      // Keyboard users keep their place; on a phone focusing a <select> reopens the native picker (iOS), so not there.
      var th = $('th[data-col="' + v + '"] select', table); if (th && !window.matchMedia('(pointer: coarse)').matches) th.focus();
    });
    applyCmp();
  }

  /* ---------- guides and FAQ ---------- */
  if (lib) {
    $$('[data-plr-grow]', lib).forEach(function (g) {
      var b = $('[data-plr-gtoggle]', g);
      function set(open) { g.classList.toggle('is-open', open); b.setAttribute('aria-expanded', String(open)); }
      g.__set = set;
      b.addEventListener('click', function () {
        var o = !g.classList.contains('is-open');
        /* Desktop: three columns sharing one panel underneath, so one group open at a time. */
        if (o && window.matchMedia('(min-width:1025px)').matches) $$('[data-plr-grow]', lib).forEach(function (x) { if (x !== g && x.__set) x.__set(false); });
        set(o); if (o) ev('guides_expand', { group: g.dataset.plrGrow });
      });
      if (q.get('gx') === g.dataset.plrGrow || location.hash.slice(1) === g.dataset.plrGrow) set(true);
    });
    var fb = $$('[data-plr-faq]', lib);
    function faq(i) {
      fb.forEach(function (b, j) { var o = j === i; b.setAttribute('aria-expanded', String(o)); document.getElementById(b.getAttribute('aria-controls')).hidden = !o; });
    }
    fb.forEach(function (b, i) { b.addEventListener('click', function () { var o = b.getAttribute('aria-expanded') === 'true'; faq(o ? -1 : i); if (!o) ev('faq_open', { index: i + 1 }); }); });
    faq(0);

  }

  /* Search inside the guides. The field is drawn once by Liquid and never touched by the listener; only the hit list
       is redrawn. Semantic: every word (up to ten, any order, AND) must appear somewhere in the guide's title or
       one-liner, or the FAQ question or answer, or the group's name. Accents fold (kok finds kök) and digits split
       from letters (66cm finds 66 cm). */
  function guideSearch(scope) {
    var gs = $('[data-plr-gs]', scope), gsOpen = $('[data-plr-gs-open]', scope);
    if (gs && gsOpen) {
      var gsIn = $('[data-plr-gs-input]', gs), gsRes = $('[data-plr-gs-res]', gs), gsCount = $('[data-plr-gs-count]', gs);
      var gsSec = gs.closest('.plr-guides, [data-gs-sec]');
      var norm = function (t) {
        return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/(\d)([a-z])/g, '$1 $2').replace(/([a-z])(\d)/g, '$1 $2').replace(/[^a-z0-9]+/g, ' ').trim();
      };
      var IDX = [];
      // Subcollection pages mark their items (data-gs-item, data-gs-grp, data-gs-t, data-gs-a); the pillar library reads its groups.
      $$('[data-gs-item]', scope).forEach(function (it) {
        var grp = it.getAttribute('data-gs-grp') || '', t = ($('[data-gs-t]', it) || it).textContent, sm = ($('[data-gs-a]', it) || {}).textContent || '';
        var href = it.getAttribute('href');
        IDX.push({ kind: href ? 'guide' : 'faq', grp: grp, href: href, t: t, sub: sm, txt: ' ' + norm(grp + ' ' + t + ' ' + sm) + ' ' });
      });
      $$('[data-plr-grow]', scope).forEach(function (g) {
        var grp = ($('.plr-grow__h', g) || {}).textContent || '';
        $$('.plr-grow__list li a', g).forEach(function (a) {
          var t = ($('.plr-grow__gt', a) || a).textContent, sm = ($('small', a) || {}).textContent || '';
          IDX.push({ kind: 'guide', grp: grp, href: a.getAttribute('href'), t: t, sub: sm, txt: ' ' + norm(grp + ' ' + t + ' ' + sm) + ' ' });
        });
        $$('.plr-qa__item', g).forEach(function (it) {
          var q = ($('.plr-qa__q', it) || {}).textContent || '', an = ($('.plr-qa__a', it) || {}).textContent || '';
          IDX.push({ kind: 'faq', grp: grp, t: q, sub: an, txt: ' ' + norm(grp + ' ' + q + ' ' + an) + ' ' });
        });
      });
      var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
      /* Words people search with that the guides do not use (Alexander's test 2026-10-31: underhåll, tvätta). A query
         word starting with a key also matches that key's stems. Keys and stems are folded (no accents). */
      var SYN = {
        underhal: ['skot', 'rengor'], tvat: ['rengor'], vard: ['skot', 'rengor'], flack: ['rengor'], stad: ['rengor'],
        skot: ['rengor'], rengor: ['skot'],
        maint: ['care', 'clean'], wash: ['clean'], stain: ['clean'], care: ['clean'], clean: ['care'],
        pfleg: ['reinig'], wasch: ['reinig'], wartung: ['pfleg', 'reinig'], fleck: ['reinig'], reinig: ['pfleg'],
        entret: ['nettoy'], laver: ['nettoy'], lavage: ['nettoy'], tache: ['nettoy'], nettoy: ['entret'],
        // our vegan leather, by the names people search; and adjustable height, which we answer with custom height
        konstlader: ['vegan'], faux: ['vegan'], kunstleder: ['vegan'], simili: ['vegan'],
        hoj: ['special'], sankbar: ['special'], adjust: ['custom'], verstellbar: ['sonder'], hohenverstell: ['sonder'], reglable: ['mesure']
      };
      var alts = function (w) {
        var a = [w];
        for (var k in SYN) if (w.indexOf(k) === 0) a = a.concat(SYN[k]);
        return a;
      };
      var has = function (x, al) { for (var i = 0; i < al.length; i++) if (x.txt.indexOf(al[i]) > -1) return true; return false; };
      var gsHits = function () {
        var words = norm(gsIn.value).split(' ').filter(Boolean).slice(0, 10);
        gsRes.textContent = '';
        if (!words.length) { gsSec.classList.remove('is-gs'); gsCount.textContent = ''; return 0; }
        gsSec.classList.add('is-gs');
        var A = words.map(alts), near = false;
        var hits = IDX.filter(function (x) { return A.every(function (al) { return has(x, al); }); });
        /* Nothing has every word: show the closest instead, ranked by how many words they share ("bygga köksö" lands
           on the island guides), and say so. */
        if (!hits.length && words.length > 1) {
          hits = IDX.map(function (x) { var n = 0; A.forEach(function (al) { if (has(x, al)) n++; }); return { x: x, n: n }; })
            .filter(function (o) { return o.n > 0; }).sort(function (a, b) { return b.n - a.n; }).slice(0, 8).map(function (o) { return o.x; });
          near = hits.length > 0;
        }
        hits.forEach(function (x) {
          var li = el('li', 'plr-gs__hit');
          var box = x.kind === 'guide' ? el('a') : el('div');
          if (x.kind === 'guide') { box.href = x.href; box.setAttribute('data-plr-guide', 'search'); }
          box.appendChild(el('span', 'plr-gs__grp', x.grp));
          box.appendChild(el('span', 'plr-gs__t', x.t));
          if (x.sub) box.appendChild(el('span', 'plr-gs__a', x.sub));
          li.appendChild(box); gsRes.appendChild(li);
        });
        gsCount.textContent = near ? gs.dataset.near : hits.length ? fmt(hits.length === 1 ? gs.dataset.one : gs.dataset.many, { n: hits.length }) : gs.dataset.none;
        return hits.length;
      };
      var gsSet = function (open) {
        gs.hidden = !open; gsOpen.setAttribute('aria-expanded', String(open));
        if (open) gsIn.focus();
        else { gsIn.value = ''; gsHits(); gsOpen.focus(); }
      };
      gsOpen.hidden = false;
      gsOpen.addEventListener('click', function () { gsSet(gs.hidden); });
      $('[data-plr-gs-close]', gs).addEventListener('click', function () { gsSet(false); });
      gsIn.addEventListener('input', gsHits);
      gsIn.addEventListener('keydown', function (e) { if (e.key === 'Escape') gsSet(false); });
      gsIn.addEventListener('change', function () { var n = gsHits(); ev('guides_search', { words: norm(gsIn.value).split(' ').filter(Boolean).length, hits: n }); });
    }
  }
  if (lib) guideSearch(lib);
  guideSearch(root);
  /* Sections that carry their own search (guides-pillar, 2026-11-03) mark themselves data-gs-scope. */
  $$('[data-gs-scope]').forEach(function (s) { if (s !== lib && s !== root) guideSearch(s); });

  /* ---------- mobile sticky bar ---------- */
  var sticky = lib && $('[data-plr-sticky]', lib), vis = { hero: true, grid: false, foot: false };
  function samplesOpen() { var d = document.querySelector('.pdp-samples'); return d && d.classList.contains('is-open'); }
  function updSticky() {
    if (!sticky) return;
    var show = MOB.matches && !vis.hero && !vis.grid && !vis.foot && !ch.open && !openDet && !samplesOpen() && !typing;
    sticky.hidden = !show;
    var s = $('[data-plr-sticky-shop]', sticky);
    s.textContent = matches ? fmt(U.sticky_matches, { n: matches.length }) : s.getAttribute('data-all');
  }
  /* While someone types (guide search, compare picker, any field) the bar steps away: with the phone keyboard up it
     sat on top of the field and the results (Alexander, iPhone SE, 2026-10-31). */
  var typing = false;
  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('input:not([type=checkbox]):not([type=radio]):not([type=range]), textarea, select')) { typing = true; updSticky(); }
  });
  document.addEventListener('focusout', function () { setTimeout(function () { var a = document.activeElement; typing = !!(a && a.matches && a.matches('input:not([type=checkbox]):not([type=radio]):not([type=range]), textarea, select')); updSticky(); }, 60); });
  if (sticky && 'IntersectionObserver' in window) {
    var foot = document.querySelector('footer, .shopify-section-group-footer-group');
    var targets = [[$('[data-io="hero"]', root) || $('[data-hero-pillar]'), 'hero'], [$('#shop'), 'grid'], [foot, 'foot']];
    var sio = new IntersectionObserver(function (es) { es.forEach(function (x) { vis[x.target.__plr] = x.isIntersecting; }); updSticky(); });
    targets.forEach(function (t) { if (t[0]) { t[0].__plr = t[1]; sio.observe(t[0]); } });
    document.addEventListener('click', function () { setTimeout(updSticky, 50); });
  }
})();
